var _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 1610.2933,
    height: 414.72,
    viewBox: "0 0 1610.2933 414.72",
    sodipodiDocname: "NEXT-logo.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,414.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10122.1,0 h 1039.7 v 2230.6 h 915.4 v 879.8 H 9206.73 v -879.8 h 915.37 V 0 Z M 5980.82,0 H 7140.55 L 7638.22,808.699 8131.44,0 H 9313.39 L 8260.3,1595.19 9268.96,3110.4 H 8109.22 L 7655.99,2368.35 7207.21,3110.4 H 6025.25 L 7033.91,1581.86 5980.82,0 Z M 3354.78,0 H 6029.73 V 853.141 H 4376.77 v 337.699 h 1519.65 v 750.94 H 4376.77 v 315.49 H 6007.51 V 3110.4 H 3354.78 V 0 Z M 0,0 H 1030.88 V 1435.23 L 2186.17,0 H 3110.4 V 3110.4 H 2079.52 V 1737.38 L 973.109,3110.4 H 0 V 0 0",
    style: {
      fill: "#1e1d1c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/NEXT.f80c5806ece90f90cadfe6197d4fef44.svg";
export { ForwardRef as ReactComponent };